import axios from "axios";

const baseurl = process.env.REACT_APP_BASE_URL;

export const getAdvisorList = async () => {
    try {
        const response = await axios.get(`${baseurl}api/advisor/advisor-list?page_number=1&limit=5&advisor_onboarding_status=Approved`);
        console.log("response", response);

        return response;
    }
    catch (error) {
        console.log("Error while getting advisor list", error.message);
    }
}

export const getPendingApprovalAdvisorList = async () => {
    try {
        const response = await axios.get(`${baseurl}api/advisor/advisor-list?page_number=1&limit=5&advisor_onboarding_status=Pending,Re-Submitted,Rejected`);
        //   console.log("response",response);

        return response;
    }
    catch (error) {
        console.log("Error while getting advisor list", error.message);
    }

}

export const getAdvisorStaticDataFn = async () => {
    try {
        const response = await axios.get(`${baseurl}api/advisor/advisor-statistics-number`);
        console.log("response", response);

        return response?.data;

    } catch (error) {
        console.log("Error while getting advisor static data", error.message);
        return error?.response?.data || error?.response;
    }
}

export const getadvisorDetailsFn = async (advisorId) => {
    try {
        const response = await axios.get(`${baseurl}api/advisor/advisor-details/${advisorId}`);
        console.log('res', response?.data);
        return response?.data;

    } catch (error) {
        console.log("error in getting advisor details", error.message)

    }
}
export const getadvisorLeadDetailsFn = async (data) => {
    try {
        const response = await axios.get(`${baseurl}api/lead/lead-list-product-by-advisor-id?advisor_id=${data?.advisor_id}&page_number=1&limit=5`);
        console.log('lead', response?.data);
        return response?.data;

    } catch (error) {
        console.log("error in getting advisor details", error.message)

    }
}

export const advisorApprovalFn = async (id) => {
    try {
        const response = await axios.put(`${baseurl}api/advisor/advisor-request-approve`, id);
        console.log('res', response?.data);
        return response;

    } catch (error) {
        console.log("error in approve advisor details", error.message)

    }
}

// export const advisorRejectFn=async(id)=>{
//     try {
//         const response=await axios.put(`${baseurl}api/advisor/advisor-request-reject`,id);
//         console.log('res',response?.data);
//         return response

//     } catch (error) {
//         console.log("error in reject advisor details",error.message)

//     }
// }

export const advisorReSubmitFn = async (data) => {
    try {
        const response = await axios.put(`${baseurl}api/advisor/advisor-request-reject`, data);
        return response;
    } catch (error) {
        console.log("error in  advisor resubmit", error.message)

    }
}

export const getComponyaccessFn = async (id) => {
    try {
        const response = await axios.get(`${baseurl}api/advisor/get-advisor-company-access?advisor_id=${id}`);
        return response;
    }
    catch (error) {
        console.log("error in getting company access", error.message)

    }
}
export const getCategoryaccessFn = async (id) => {
    try {
        const response = await axios.get(`${baseurl}api/advisor/get-advisor-category-access?advisor_id=${id}`);
        return response;
    }
    catch (error) {
        console.log("error in getting category access", error.message)

    }
}
export const changeAdvisorCompanyAccessFn = async (data) => {
    console.log('input data', data);

    try {
        const response = await axios.put(`${baseurl}api/advisor/upsert-advisor-company-access`, data);
        return response;
    }
    catch (error) {
        console.log("error in getting category access", error.message)

    }
}
export const changeAdvisorCategoryAccessFn = async (data) => {
    try {
        const response = await axios.put(`${baseurl}api/advisor/upsert-advisor-category-access`, data);
        return response;
    }
    catch (error) {
        console.log("error in getting category access", error.message)

    }
}
export const changeAdvisorStatusFn = async (data) => {
    try {
        const response = await axios.put(`${baseurl}api/advisor/active-inactive-advisor`, data);
        return response;
    }
    catch (error) {
        console.log("error in getting category access", error.message)

    }
}

export const getAllcategoriesFn = async () => {
    try {
        const response = await axios.get(`${baseurl}api/category/?is_all=true`);
        console.log('allcatagories', response);

        return response;

    } catch (error) {
        console.log("error getting all catagories", error.message);

    }
}

export const getAllcompanyFn = async () => {
    try {
        const response = await axios.get(`${baseurl}api/company/company-list?is_all=true`);
        console.log('allcompany', response);

        return response;

    } catch (error) {
        console.log("error getting all catagories", error.message);

    }
}

export const getAdvisorStaticDataById = async (id) => {
    try {
        const response = await axios.get(`${baseurl}api/advisor/advisor-statistics-by-advisor-id?advisor_id=${id}`);

        return response;

    } catch (error) {
        console.log("error getting static data by id", error.message);

    }
}
